import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

// Material Icons
import MenuIcon from '@material-ui/icons/Menu';
import Raven from 'raven-js';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import swal from 'sweetalert2';

import { openLoginDialog, closeLoginDialog } from '../../modules/login';
import { openSignupDialog, closeSignupDialog } from '../../modules/signup';
import {
  openPrimaryContactDialog,
  closePrimaryContactDialog
} from '../../modules/app';
import {
  closeForgotPasswordDialog,
  openForgotPasswordDialog
} from '../../modules/forgotpassword';

import { logout } from '../../modules/user';

// Components
import LoginDialog from '../LoginDialog';
import PrimaryContactDialog from '../PrimaryContactDialog';
import ForgotPasswordDialog from '../ForgotPasswordDialog';

const styles = {
  root: {
    // display: 'fixed',
    flexGrow: 1
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  }
};

class Header extends Component {
  componentDidMount() {
    // If user logged in, set context
    const { user, loggedIn } = this.props;
    if (loggedIn) {
      // Raven.setUserContext({ email: user.email, name: user.name });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // If user logged in, set context
    const { user, loggedIn } = this.props;
    if (!prevProps.loggedIn && loggedIn) {
      // Raven.setUserContext({ email: user.email, name: user.name });
    }
  }

  _handleLogout = () => {
    this.props.logout();
    swal({
      position: 'top-end',
      type: 'success',
      title: 'Successfully logged out',
      showConfirmButton: false,
      timer: 1500
    });
  };

  _handleOpenLoginDialog = () => {
    this.props.openLoginDialog();
  };

  // _handleOpenSignupDialog = () => {
  //   this.props.openSignupDialog();
  // }

  _handleCloseLoginDialog = () => {
    this.props.closeLoginDialog();
  };

  // _handleCloseSignupDialog = () => {
  //   this.props.closeSignupDialog();
  // }

  _handleCloseForgotPasswordDialog = () => {
    this.props.closeForgotPasswordDialog();
  };

  // user already has account
  _handleLoginInstead = () => {
    this.props.closeForgotPasswordDialog();
    this.props.openLoginDialog();
  };

  _handleSignupInstead = () => {
    this.props.closeLoginDialog();
    this.props.closeForgotPasswordDialog();
  };

  _handleForgotPassword = () => {
    this.props.closeLoginDialog();
    this.props.openForgotPasswordDialog();
  };

  _handleClosePrimaryContactDialog = () => {
    this.props.closePrimaryContactDialog();
  };

  render() {
    const { classes, user, loggedIn } = this.props;

    return (
      <div className={classes.root}>
        <AppBar position="fixed">
          <Toolbar>
            <Typography
              variant="title"
              color="inherit"
              className={classes.flex}>
              Food For Change
            </Typography>

            {/* Maybe Render Login button */}
            {!user && !loggedIn && (
              <Button onClick={this._handleOpenLoginDialog} color="inherit">
                Login
              </Button>
            )}

            {/* Logout Button */}
            {!!user && !!loggedIn && (
              <Button onClick={this._handleLogout} color="inherit">
                Logout
              </Button>
            )}
          </Toolbar>
        </AppBar>

        <LoginDialog
          open={this.props.loginDialogOpen}
          handleClose={this._handleCloseLoginDialog}
          handleSignup={this._handleSignupInstead}
          handleForgotPassword={this._handleForgotPassword}
        />

        <PrimaryContactDialog
          open={this.props.primaryContactDialogOpen}
          handleClose={this._handleClosePrimaryContactDialog}
        />

        <ForgotPasswordDialog
          open={this.props.forgotPasswordDialogOpen}
          handleClose={this._handleCloseForgotPasswordDialog}
          handleLogin={this._handleLoginInstead}
          handleSignup={this._handleSignupInstead}
        />
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

Header = withStyles(styles)(Header);

const mapStateToProps = state => ({
  loginDialogOpen: state.login.loginDialogOpen,
  forgotPasswordDialogOpen: state.forgotpassword.forgotPasswordDialogOpen,
  primaryContactDialogOpen: state.app.primaryContactDialogOpen,
  user: state.user.data,
  loggedIn: state.user.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openLoginDialog,
      closeLoginDialog,
      openForgotPasswordDialog,
      closeForgotPasswordDialog,
      openPrimaryContactDialog,
      closePrimaryContactDialog,
      logout: () => logout(),
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js